import api from './api';
import types from './mutation-types';

export default {
	async getCommCodeDetails_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodeDetails(codeType);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body.resultList });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'srchMm01List',
						value: data !== null && data !== undefined ? data.body.SRCH_MM_01 : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'srchMm02List',
						value: data !== null && data !== undefined ? data.body.SRCH_MM_02 : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'carScnList',
						value: data !== null && data !== undefined ? data.body.CAR_SCN : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pacScnList',
						value: data !== null && data !== undefined ? data.body.PAC_SCN : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'partTypeList',
						value: data !== null && data !== undefined ? data.body.PART_G : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'plntCdList',
						value: data !== null && data !== undefined ? data.body.PLNT_CD : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'flclSpcList',
						value: data !== null && data !== undefined ? data.body.FLCL_SPC : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'cTypeList',
						value: data !== null && data !== undefined ? data.body.CTYPE : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'phmnCdList',
						value: data !== null && data !== undefined ? data.body.PHMN_CD : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'saleNatList',
						value: data !== null && data !== undefined ? data.body.SALE_NAT : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'occuRegnList',
						value: data !== null && data !== undefined ? data.body.OCCU_REGN : null
					});
					// commit(types.DEFAULT_ASSIGN, {
					// 	key: 'carTypeNmList',
					// 	value: data !== null && data !== undefined ? data.body.CAR_TYPE_NM : null
					// });
					commit(types.DEFAULT_ASSIGN, {
						key: 'idxScnList',
						value: data !== null && data !== undefined ? data.body.IDX_SCN : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'opCdList',
						value: data !== null && data !== undefined ? data.body.OP_CD : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	getPcQrtyList_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getPcQrtyList({ searchParams: searchParams })
			.then(data => {
				if (data.header.code === 0) {
					//그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'pcQrtyList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
					// 리스트 그래프 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphLineChartInfo',
						value: data !== null && data !== undefined ? data.body.lineList : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getGraphList_({ commit, state }) {
		const { searchParams } = state;
		return api
			.getGraphList({ searchParams })
			.then(data => {
				if (data.header.code === 0) {
					// 바스택 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphBarStackChartInfo',
						value: data !== null && data !== undefined ? data.body.graphBarStackChartInfo : null
					});

					// 파이 그래프 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphPieResultList',
						value: data !== null && data !== undefined ? data.body.graphPieChartInfo : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
